import { Component } from '@angular/core';
import { Key, Navigator, sort } from '@kpd/framework-ngx';
import { LicenseFacade } from 'app/shared/services/facades/license.facade';
import { LicensesNavigatorHelper } from 'app/licenses/licenses-navigator-helper';
import { License } from 'app/shared/models/license';
import { LicenseService } from 'app/shared/services/license.service';
import { User } from 'app/shared/models/user';
import { Permissions } from 'app/shared/services/permissions';

@Component({
  selector: 'app-license-sidepanel',
  templateUrl: './licenses-sidepanel.component.html',
})
export class LicensesSidepanelComponent {
  Permissions: typeof Permissions = Permissions;
  navigatorHelper: LicensesNavigatorHelper;
  licenseUsers: User[] = [];
  usersLoading = false;

  constructor(
    private navigator: Navigator,
    public licenseFacade: LicenseFacade,
    private licenseService: LicenseService,
  ) {
    this.navigatorHelper = new LicensesNavigatorHelper(navigator);
  }

  onView(key: Key<string>): void {
    this.navigatorHelper.navigateToConsult(key);
  }

  onItemChange(item: License): void {
    if (!!item && !!item.key && item.key.isDefined()) {
      this.usersLoading = true;
      this.licenseService.getLicenseUsers(item.key).subscribe((users) => {
        this.licenseUsers = sort(users, { name: 'displayName' });
        this.usersLoading = false;
      });
    }
  }

  navigateToUsers(key: Key<string>): void {
    this.navigator.navigateChild(['licenses', 'details', 'license', key.id], {
      queryParams: { tab: 'users' },
    });
  }
}
